export { ABMTableModule } from './abmtable.module';
export { ABMTableComponent } from './abmtable.component';
export * from './interfaces';
